export const hvModel: string[] = [
  '10',
  '20',
  '30',
  '60',
  '90',
  '120',
  '150',
  '180'
];

export const hvModelAlt: string[] = [
  '30',
  '60',
  '90',
  '120',
  '150',
  '180'
];

export const ivxModel: string[] = [
  '7',
  '14',
  '21',
  '30',
  '60',
  '90',
  '120',
  '150',
  '180',
  '270',
  '360',
  '720',
  '1080'
];

export const ivxModelAlt: string[] = [
  '30',
  '60',
  '90',
  '120',
  '150',
  '180'
];

export const futIvxModel: string[] = [
  '30',
  '60',
  '90',
  '120',
  '150',
  '180'
];

export const futHvModel: string[] = [
  '30',
  '60',
  '90',
  '120',
  '150',
  '180'
];
